export const GoalType = {
    moreImpressionsGRPs: {
        label: 'More Impressions/GRPs',
        value: 'moreImpressionsGRPs',
        goalTypeDescription: 'Your ad will be seen as many times as possible'
    },
    moreReach: {
        label: 'More Reach',
        value: 'moreReach',
        goalTypeDescription: 'Your ad will be seen by the maximum number of people possible'
    },
    // deprecated
    // morePrimeTimeSlots: {
    //     label: 'More Prime Time Slots',
    //     value: 'morePrimeTimeSlots',
    //     goalTypeDescription: 'Majority of your ads will appear in the most popular programmes'
    // }
}
